import { concatStyleSetsWithProps, Toggle, IToggleProps } from '@fluentui/react'
import { toggleStyles } from './cr-toggle.styles'

export const CrToggle: React.FC<IToggleProps> = (props) => (
  <Toggle {...props} styles={(stylesProps) => concatStyleSetsWithProps(stylesProps, ...[toggleStyles, props.styles])} />
)
